import { memo, useMemo } from 'react';
import Slider from '@dtvgo/slider';
import Tooltip from '@dtvgo/tooltip';
import { ProgressBarClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function DotTooltip(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$arrowPlacement = _ref.arrowPlacement,
    arrowPlacement = _ref$arrowPlacement === void 0 ? 'center' : _ref$arrowPlacement,
    _ref$tooltipBgColor = _ref.tooltipBgColor,
    tooltipBgColor = _ref$tooltipBgColor === void 0 ? '' : _ref$tooltipBgColor,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsx(Slider.DotTemplate, {
    className: ProgressBarClassNames.element('dot-tooltip', className),
    value: value,
    children: useMemo(function () {
      return children && /*#__PURE__*/jsx(Tooltip, {
        placement: placement,
        arrowPlacement: arrowPlacement,
        bgColor: tooltipBgColor,
        children: children
      });
    }, [arrowPlacement, children, placement, tooltipBgColor])
  });
}
var DotTooltip$1 = /*#__PURE__*/memo(DotTooltip);

export { DotTooltip$1 as default };
//# sourceMappingURL=DotTooltip.js.map
